import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import TipTapEditor from "../../common/TipTapEditor"; 
import { useIntl } from "react-intl";

const DescriptionField = ({
  disabled,
  editable,
  onChange,
  onDirty,
  reset,
  value
}) => {
  const [editValue, setEditValue] = useState(value || "");
  const [dirty, setDirty] = useState(false);
  const intl = useIntl();
  // Reset handling
  useEffect(() => {
    if (reset) {
      setEditValue(value || "");
      setDirty(false);
    }
  }, [reset, value]);

  // Dirty state tracking
  useEffect(() => {
    const isDirty = editValue !== (value || "");
    if (isDirty !== dirty) {
      setDirty(isDirty);
      onDirty?.({ dirty: isDirty });
    }
  }, [editValue, value, dirty, onDirty]);

  const handleChange = (newValue) => {
    setEditValue(newValue);
    if (newValue !== value) {
      onChange?.({ value: newValue });
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid transparent",
        borderRadius: "4px",
        "&:hover": editable && !disabled
          ? {
            cursor: "text",
          }
          : {},
      }}
    >
      <TipTapEditor
        value={editValue}
        onChange={handleChange}
        editable={!disabled && editable}
        placeholder={intl.formatMessage({ "id": "project.description" }) /* Only the initial value will be displayed. */}
      />
    </Box>
  );
};

export default DescriptionField;
